// extracted by mini-css-extract-plugin
export var productImage = "_zf-0";